<div class="drawer-form-wrapper">
  <nz-upload
    [(nzFileList)]="fileList"
    [nzRemove]="handleRemove"
    class="file-upload"
    [nzMultiple]="false"
    [nzBeforeUpload]="beforeUpload"
    [nzIconRender]="iconTemplate"
    [nzShowUploadList]="{ showPreviewIcon: true }"
    nzListType="picture"
    nzAccept=".png,.jpg,.jpeg"
    (nzChange)="handleChange($event)"
    [nzDisabled]="loading"
    nzDrop>
    <button nz-button type="button" [disabled]="loading">
      <div class="upload-icon">
        <svg-icon
          [title]="'Upload Image'"
          src="/assets/icon/icon-upload.svg"
          class="icon s-12"></svg-icon>
      </div>
      <div class="wrapper">
        <p class="text s-14 fw-600 green">
          Click to upload
          <span class="text s-14 fw-400">or drag and drop</span>
        </p>
        <p class="text s-12 fw-400">Supported formats: jpg, jpeg & png</p>
      </div>
    </button>
  </nz-upload>

  <div *ngIf="(loading$ | async) && !previewImage" class="text-center mt-16">
    <nz-spin nzSimple></nz-spin>
    <p class="text s-12 fw-400 mt-8">Loading image...</p>
  </div>

  <div class="mt-16" *ngIf="!!previewImage">
    <img [src]="previewImage" style="width: 100%" alt="student image" />
  </div>
</div>

<div class="display-flex justify-content-between drawer-footer">
  <button
    type="button"
    nz-button
    nzType="default"
    [disabled]="loading || isUploadingImage"
    (click)="closeDrawer()">
    Cancel
  </button>
  <button
    type="button"
    nz-button
    nzType="primary"
    [nzLoading]="isUploadingImage"
    [disabled]="!fileList.length || loading"
    (click)="onEdit()">
    {{ isUploadingImage ? 'Uploading...' : 'Upload' }}
  </button>
</div>

<ng-template #iconTemplate let-file>
  <svg-icon
    src="/assets/icon/icon-report-green.svg"
    class="icon s-12"></svg-icon>
</ng-template>
